import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const Gallery = () => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const sliderRef2 = useRef(null);
  const sliderRef3 = useRef(null);

  const [lightbox, setLightbox] = useState({
    open: false,
    slides: [],
    index: 0,
  });

  const openLightbox = (slides, index) => {
    setLightbox({
      open: true,
      slides,
      index,
    });
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    centerMode: false,
    centerPadding: "0px",
    arrows: false, // We are using custom arrows
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slider3Settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    centerMode: false,
    centerPadding: "0px",
    arrows: false, // We are using custom arrows
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slider1Content = [
    <div className="image-card" key={0}>
      <img src="images/I13.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/new_33.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/I12.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0612p.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0561-HDR.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0518.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/pic_08.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_3268.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0007p5.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/sky_06.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/sky_04.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0033p7.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/I13.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/new_33.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/I12.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0612p.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0561-HDR.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0518.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/pic_08.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_3268.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0007p5.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/sky_06.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/sky_04.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/DDK_0033p7.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/I13.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/new_33.jpg" />
    </div>,
    <div className="image-card" key={0}>
      <img src="images/I12.jpg" />
    </div>,
  ];

  const slider2Content = [
    <div className="image-card" key={0}>
      <img src="/images/bridge.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/panda.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/4.jpg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/macau_transit.jpg" alt="" />
    </div>,

    <div className="image-card" key={4}>
      <img src="/images/new_14.jpg" alt="" />
    </div>,
    <div className="image-card" key={5}>
      <img src="/images/mmexport1747815841641.jpg" alt="" />
    </div>,
    <div className="image-card" key={6}>
      <img src="/images/school.jpg" alt="" />
    </div>,
    <div className="image-card" key={7}>
      <img src="/images/M2.jpg" alt="" />
    </div>,
    <div className="image-card" key={8}>
      <img src="/images/waterfront.jpg" alt="" />
    </div>,
    <div className="image-card" key={9}>
      <img src="/images/WhatsApp Image 2025-05-21 at 6.37.52 PM.jpeg" alt="" />
    </div>,
    <div className="image-card" key={10}>
      <img
        src="/images/WhatsApp Image 2025-05-21 at 6.27.54 PM (1).jpeg"
        alt=""
      />
    </div>,
    <div className="image-card" key={11}>
      <img src="/images/WhatsApp Image 2025-05-21 at 6.31.43 PM.jpeg" alt="" />
    </div>,
  ];

  const slider3Content = [
    <div className="image-card" key={0}>
      <img src="/images/new_30.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/new_43.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_24.jpg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/new_46.jpg" alt="" />
    </div>,
  ];

  const slides1 = slider1Content.map((card) => ({
    src: card.props.children.props.src,
  }));
  const slides2 = slider2Content.map((card) => ({
    src: card.props.children.props.src,
  }));
  const slides3 = slider3Content.map((card) => ({
    src: card.props.children.props.src,
  }));

  return (
    <ImageLoader>
      <Container>
        <Row className="section">
          <Col md={12} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("gallery_main_title")}</h2>
            </AnimateOnScroll>
          </Col>
          <Col md={12}>
            <AnimateOnScroll animationType="slideUp">
              <iframe
                style={{ width: "100%", aspectRatio: "22/9" }}
                src="https://www.youtube.com/embed/suO9mx0PAHQ?autoplay=1&mute=1&loop=1&playlist=suO9mx0PAHQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </AnimateOnScroll>
            <hr />
          </Col>

          <Col md={12} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("gallery_residence_title")}</h2>
            </AnimateOnScroll>
          </Col>
          <Col md={12}>
            <AnimateOnScroll animationType="slideUp">
              <div className="sigle-slider ">
                <Slider ref={sliderRef} {...sliderSettings}>
                  {slider1Content.map((card, idx) =>
                    React.cloneElement(card, {
                      onClick: () => openLightbox(slides1, idx),
                    }),
                  )}
                </Slider>
                <div className="slider-arrows">
                  <button
                    className="slick-prev-custom"
                    onClick={() => sliderRef.current.slickPrev()}
                  >
                    <FaArrowLeft />
                  </button>
                  <button
                    className="slick-next-custom"
                    onClick={() => sliderRef.current.slickNext()}
                  >
                    <FaArrowRight />
                  </button>
                </div>
              </div>
            </AnimateOnScroll>
            <hr />
          </Col>

          <Col md={7} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideLeft">
              <img src="/images/pool.jpg" alt="One Oasis" className="fullimg" />
            </AnimateOnScroll>
          </Col>

          <Col md={5} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideRight">
              <h2>{t("gallery_amenities_title")}</h2>
              <p>{t("gallery_amenities_p")}</p>
            </AnimateOnScroll>
            <AnimateOnScroll animationType="slideUp">
              <div className="sigle-slider ">
                <Slider ref={sliderRef3} {...slider3Settings}>
                  {slider3Content.map((card, idx) =>
                    React.cloneElement(card, {
                      onClick: () => openLightbox(slides3, idx),
                    }),
                  )}
                </Slider>
                <div className="slider-arrows">
                  <button
                    className="slick-prev-custom"
                    onClick={() => sliderRef3.current.slickPrev()}
                  >
                    <FaArrowLeft />
                  </button>
                  <button
                    className="slick-next-custom"
                    onClick={() => sliderRef3.current.slickNext()}
                  >
                    <FaArrowRight />
                  </button>
                </div>
              </div>
            </AnimateOnScroll>
          </Col>

          <Col md={12} className="d-flex flex-column justify-content-center">
            <hr />
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("gallery_neighborhoods_title")}</h2>
              <p>{t("gallery_neighborhoods_p")}</p>
            </AnimateOnScroll>
          </Col>
          
          <Col md={12} className="d-flex flex-column justify-content-center">
          <Row className="bottom-padding">
            <AnimateOnScroll animationType="slideUp">
              <img src="/images/M2.jpg" alt="One Oasis" className="fullimg" />
            </AnimateOnScroll>
            </Row>
          </Col>
          

          <Col md={12}>
          
            <AnimateOnScroll animationType="slideUp">
              <div className="sigle-slider ">
                <Slider ref={sliderRef2} {...sliderSettings}>
                  {slider2Content.map((card, idx) =>
                    React.cloneElement(card, {
                      onClick: () => openLightbox(slides2, idx),
                    }),
                  )}
                </Slider>
                <div className="slider-arrows">
                  <button
                    className="slick-prev-custom"
                    onClick={() => sliderRef2.current.slickPrev()}
                  >
                    <FaArrowLeft />
                  </button>
                  <button
                    className="slick-next-custom"
                    onClick={() => sliderRef2.current.slickNext()}
                  >
                    <FaArrowRight />
                  </button>
                </div>
              </div>
            </AnimateOnScroll>
            
            <hr />
          </Col>
        </Row>
        <Lightbox
          open={lightbox.open}
          close={() => setLightbox({ ...lightbox, open: false })}
          slides={lightbox.slides}
          index={lightbox.index}
        />
      </Container>
    </ImageLoader>
  );
};
export default Gallery;
